import { TextareaHTMLAttributes } from 'react'
import styles from './styles.module.scss'

interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> { }

export function TextAreaField({ ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className={styles.jsonTextarea}
    />
  )
}

export function TextAreaErrors({ ...rest }: TextareaProps) {
  return (
    <textarea
      {...rest}
      className={styles.jsonTextareaErrors}
    />
  )
}